<template>
  <v-card-actions>
    <slot />
  </v-card-actions>
</template>
